import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col relative" }
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-gray-500"
}
const _hoisted_4 = { class: "font-bold" }
const _hoisted_5 = { class: "text-xs text-gray-500" }
const _hoisted_6 = { type: "button" }
const _hoisted_7 = {
  key: 0,
  class: "text-sm absolute z-10 w-full bg-white px-1 py-1 top-[4rem] border border-gray-300 rounded-md shadow divide-y max-h-64 overflow-auto"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "text-xs text-gray-500 group-hover:text-blue-100" }
const _hoisted_11 = {
  key: 1,
  class: "text-sm absolute z-10 w-full bg-white px-1 py-1 top-[4rem] border border-gray-300 rounded-md shadow divide-y max-h-48 overflow-auto"
}
const _hoisted_12 = {
  key: 0,
  class: "group flex flex-col gap-1 py-1 px-2 hover:bg-wm-blue rounded-md hover:text-white cursor-pointer"
}
const _hoisted_13 = { class: "text-xs text-gray-500" }
const _hoisted_14 = {
  key: 1,
  class: "group flex flex-col gap-1 py-1 px-2 hover:bg-wm-blue rounded-md hover:text-white cursor-pointer"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_wm_input = _resolveComponent("wm-input")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "form-label" }, "Distrito:", -1 /* CACHED */)),
        (!_ctx.required)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Opcional"))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", {
        class: "border bg-white flex items-center gap-2 justify-between w-full pl-4 pr-2 py-2 border-black rounded-lg",
        onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.resetDistrict && _ctx.resetDistrict(...args)))
      }, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.pickedDistrict.name), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.pickedDistrict.province) + " - " + _toDisplayString(_ctx.pickedDistrict.region), 1 /* TEXT */)
        ]),
        _createElementVNode("button", _hoisted_6, [
          _createElementVNode("span", {
            class: "hover:underline font-bold cursor-pointer text-wm-blue text-sm",
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.resetDistrict && _ctx.resetDistrict(...args)))
          }, [
            _createCommentVNode(" pencil icon "),
            _cache[5] || (_cache[5] = _createElementVNode("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              class: "text-blue-300 size-6",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                fill: "#93C5FD",
                d: "m7.43 15.92 1.26-3.16a4 4 0 0 1 .89-1.34L16.5 4.5a2.12 2.12 0 0 1 3 3l-6.92 6.92a4 4 0 0 1-1.34.88l-3.16 1.27a.5.5 0 0 1-.65-.65Z"
              }),
              _createElementVNode("path", {
                fill: "#93C5FD",
                d: "M5.5 7.75c0-.69.56-1.25 1.25-1.25H12A.75.75 0 0 0 12 5H6.75A2.75 2.75 0 0 0 4 7.75v9.5A2.75 2.75 0 0 0 6.75 20h9.5A2.75 2.75 0 0 0 19 17.25V12a.75.75 0 0 0-1.5 0v5.25c0 .69-.56 1.25-1.25 1.25h-9.5c-.69 0-1.25-.56-1.25-1.25v-9.5Z"
              })
            ], -1 /* CACHED */))
          ])
        ])
      ])
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.pickedDistrictId]
    ]),
    _withDirectives(_createVNode(_component_wm_input, {
      ref: "input",
      label: "Distrito",
      modelValue: _ctx.districtQuery,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.districtQuery) = $event)),
      "error-message": "Campo requerido",
      required: _ctx.required,
      placeholder: "ej. Miraflores",
      isForm: _ctx.isForm,
      onKeydown: _ctx.fetchDistricts,
      onFocus: _cache[3] || (_cache[3] = $event => (_ctx.showResults = true)),
      onBlur: _ctx.hideResults
    }, null, 8 /* PROPS */, ["modelValue", "required", "isForm", "onKeydown", "onBlur"]), [
      [_vShow, _ctx.pickedDistrictId == 0]
    ]),
    (_ctx.showResults && _ctx.districtList.length)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.districtList, (district) => {
            return (_openBlock(), _createElementBlock("li", {
              key: district.id,
              class: "group flex flex-col gap-1 py-1 px-2 hover:bg-wm-blue rounded-md hover:text-white cursor-pointer",
              onClick: $event => (_ctx.pickDistrict(district))
            }, [
              _createElementVNode("span", {
                class: "font-bold",
                innerHTML: _ctx.highlightMatch(district.name, _ctx.districtQuery)
              }, null, 8 /* PROPS */, _hoisted_9),
              _createElementVNode("div", _hoisted_10, _toDisplayString(district.province) + " - " + _toDisplayString(district.region), 1 /* TEXT */)
            ], 8 /* PROPS */, _hoisted_8))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : (_ctx.showResults && !_ctx.districtList.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
            (!_ctx.searching)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "font-bold" }, "No se encontraron resultados", -1 /* CACHED */)),
                  _createElementVNode("div", _hoisted_13, " No se encontraron distritos que coincidan con \"" + _toDisplayString(_ctx.districtQuery) + "\" ", 1 /* TEXT */)
                ]))
              : (_openBlock(), _createElementBlock("li", _hoisted_14, [...(_cache[7] || (_cache[7] = [
                  _createElementVNode("span", { class: "font-bold" }, "Buscando...", -1 /* CACHED */),
                  _createElementVNode("div", { class: "text-xs text-gray-500" }, " Por favor espere ", -1 /* CACHED */)
                ]))]))
          ]))
        : _createCommentVNode("v-if", true)
  ]))
}